<template>
  <v-card>
    <vue-card-title
      :title="'Sales Stages'"
      :subtitle="'Refer to the following information on Sales Stages.'"
      :icon="$getIcon('mdiClipboardTextOutline')"
    >
      <template slot="actions">
        <v-btn
          v-if="fetched"
          class="indigo accent-2 white--text text-capitalize my-0"
          small
          @click="salesStageForm = true"
        >
          Create Sales Stage
        </v-btn>
      </template>
    </vue-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row v-if="!fetched" align="center" justify="center">
        <v-col md="12">
          <vue-default-svg-loader></vue-default-svg-loader>
        </v-col>
      </v-row>
      <v-row
        v-else-if="fetched && salesStages.length > 0"
        align="center"
        justify="center"
        class="mb-3"
      >
        <v-col
          v-for="(stage, stageIndex) in salesStages"
          :key="stageIndex"
          class="d-inline-flex align-center"
        >
          <v-hover>
            <div slot-scope="{ hover }">
              <v-card
                :class="
                  `elevation-${
                    hover || stage.id === selectedStageId
                      ? `3 grey lighten-3`
                      : `2`
                  }`
                "
                class="pointer border"
              >
                <v-card-text class="text-center">
                  <h4
                    class="blue--text font-weight-bold cursor-pointer"
                    @click="
                      (showSubStages = true) &&
                        (selectedStage = stage.name) &&
                        (selectedStageId = stage.id)
                    "
                  >
                    {{ stage.name }}
                  </h4>
                  <small class="d-block"
                    >{{ stage.stage_type }} / {{ stage.order }}</small
                  >
                </v-card-text>
              </v-card>
              <div class="text-center">
                <a
                  class="font-0 grey--text cursor-pointer link"
                  @click="
                    (selectedSalesStageData = stage) && (salesStageForm = true)
                  "
                  >Update</a
                >
                <span class="mx-1 font-0 grey--text">|</span>
                <a
                  class="font-0 grey--text cursor-pointer link"
                  @click="
                    (selectedSalesStageData = stage) &&
                      (confirmSalesStageDelete = true)
                  "
                  >Delete</a
                >
              </div>
            </div>
          </v-hover>
          <div v-if="stageIndex + 1 < salesStages.length" class="text-center">
            <v-icon v-text="$getIcon('mdiTrendingNeutral')"> </v-icon>
          </div>
        </v-col>
        <v-col md="12">
          <v-slide-y-transition>
            <div v-if="showSubStages">
              <manage-sales-sub-stages
                :sales-stage-form="salesStageForm"
                :show-sub-stages.sync="showSubStages"
                :selected-stage="selectedStage"
                :selected-stage-id="selectedStageId"
              ></manage-sales-sub-stages>
            </div>
          </v-slide-y-transition>
        </v-col>
      </v-row>
      <v-row v-else>
        <vue-no-data
          text="Sales stages not found. Please create to continue."
        ></vue-no-data>
      </v-row>
    </v-card-text>
    <!-- Sales Stage Form -->
    <v-bottom-sheet v-model="salesStageForm" scrollable>
      <v-card tile>
        <vue-card-title
          :display-card.sync="salesStageForm"
          :title="cardTitle"
          :subtitle="'Fill up the following form to action on sales stage.'"
          :icon="$getIcon('mdiFileDocumentEdit')"
          closable
          @close="salesStageForm = false"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <sales-stage-form
            v-if="selectedSalesStageData && salesStageForm"
            :action-data="selectedSalesStageData"
            @salesStageResponse="formSuccess"
          >
          </sales-stage-form>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <!-- / Sales Stage Form -->
    <!-- Confirm Sales Stage Delete -->
    <v-dialog v-model="confirmSalesStageDelete" persistent max-width="390">
      <v-card>
        <vue-card-title
          :title="'Confirm Sales Stage Deletion'"
          :icon="$getIcon('mdiClipboardTextOutline')"
        >
          <template slot="actions">
            <v-btn icon small dark @click="confirmSalesStageDelete = false">
              <v-icon v-text="$getIcon('mdiClose')" small> </v-icon>
            </v-btn>
          </template>
        </vue-card-title>
        <v-card-text>
          Are you sure you want to delete the sales stage -
          {{ selectedSalesStageData.name }}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="
              selectedSalesStageData = {} && (confirmSalesStageDelete = false)
            "
          >
            No
          </v-btn>
          <v-btn color="green darken-1" text @click="deleteSalesStage()">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Confirm Sales Stage Delete -->
  </v-card>
</template>
<script>
import ManageSalesSubStages from "@/components/crm/configuration/crm_settings/ManageSalesSubStages";
import SalesStageForm from "@/components/crm/configuration/sales_stage/forms/SalesStageForm";

export default {
  components: {
    SalesStageForm,
    ManageSalesSubStages
  },
  data() {
    return {
      showSubStages: false,
      selectedStage: "",
      selectedStageId: "",
      selectedOrganization: "",
      // form
      fetched: false,
      salesStageForm: false,
      selectedSalesStageData: {},
      cardTitle: "",
      orgSlug: this.$store.state.shell.currentOrganizationId,
      salesStages: [],
      confirmSalesStageDelete: false
    };
  },
  watch: {
    salesStageForm(newVal) {
      if (Object.keys(this.selectedSalesStageData).length > 0 && newVal) {
        this.cardTitle = "Update Sales Stage";
      } else {
        this.selectedSalesStageData = {};
        this.cardTitle = "Create Sales Stage";
      }
    },
    showSubStages(val) {
      if (!val) {
        this.selectedStage = "";
        this.selectedStageId = "";
      }
    }
  },
  mounted() {
    this.fetchSalesStages();
  },
  methods: {
    fetchSalesStages() {
      const salesStageURL = "/api/v1/crm/sales-stages/?fetch_all=true";
      const params = {
        organization__slug: this.orgSlug
      };
      this.fetched = false;
      this.$axios.$get(salesStageURL, { params }).then(response => {
        this.salesStages = response;
        this.fetched = true;
      });
    },
    formSuccess() {
      this.salesStageForm = false;
      this.showSubStages = false;
      this.fetchSalesStages();
    },
    deleteSalesStage() {
      const deleteURL = `/api/v1/crm/sales-stages/${this.selectedSalesStageData.id}/?organization__slug=${this.$store.state.shell.currentOrganizationId}`;
      this.$axios.$delete(deleteURL).then(() => {
        this.$store.dispatch("shell/showSnackbar", {
          text: `Successfully deleted sales stage.`,
          color: "green"
        });
        this.confirmSalesStageDelete = false;
        this.selectedSalesStageData = {};
        this.fetchSalesStages();
      });
    }
  }
};
</script>
